import logo from './logo.svg';
import './App.css';
import Home from './components/Home';

function App() {
  return (
    <div className="App" style={{minHeight:`${window.innerHeight}px`, height:`${window.innerHeight}`, color:'black'}}>
      <Home/>
    </div>
  );
}

export default App;
